// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-gm3v","colBig":"styles_colBig__3q-lE","colSmall":"styles_colSmall__1Kqmi"};